// extracted by mini-css-extract-plugin
export default {"legend_fixed_container":"LegendFixed_legend_fixed_container__1zihm","close_btn":"LegendFixed_close_btn__99tsZ","close_legend_container":"LegendFixed_close_legend_container__vb3HN"};